import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { KeyWord } from 'src/app/shared/classes/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BulkContentEditorComponent } from 'src/app/content-editor/bulk-content-editor/bulk-content-editor.component';
import { CookieService } from 'ngx-cookie-service';
import { Socket } from 'ngx-socket-io';
import { LckrService } from 'src/app/shared/services/lckr.service';
import { BulkAuditComponent } from 'src/app/audit/bulk-audit/bulk-audit.component';
Chart.register(...registerables);
@Component({
  selector: 'app-google-search-console',
  templateUrl: './google-search-console.component.html',
  styleUrls: ['./google-search-console.component.scss'],
})
export class GoogleSearchConsoleComponent implements OnInit {

  activeNav: string = "clicks";
  activeLink: string = "QUERY";
  allCount = 10;
  page = 1;
  selected: string = "";
  public chart!: Chart;
  siteData: any = [];
  gscData: any[] = [];
  queryData: any[] = [];
  accessToken: string = '';
  Math?: Math;
  tableSize!: number;
  tabWiseCount: any;
  count: number = 4;
  totalData: string = "0";
  paginateData: any;
  keyWordData: any;
  backupGscData: any;
  totalClicks: boolean = false;
  totalImpressions: boolean = false;
  avgCtr: boolean = false;
  avgPosition: boolean = false;
  date: string = "28";
  labels: any[] = [];
  clickData: any[] = [];
  impressionData: any[] = [];
  ctrData: any[] = [];
  positionData: any[] = [];
  startDate!: any;
  endDate!: any;
  customStartDate!: any;
  customEndDate!: any;
  dialogRef: any;
  dateValue: string = "";
  minDate = new Date(2022, 0, 1);
  maxDate = new Date();
  // recentDate = new Date().getDate() - 1;
  radioArr = [
    // {value:'recent Date',text:`Most recent Date (${new Date().toLocaleDateString('en-us', { year:"numeric", month:"long", day:"numeric"})})`},
    { value: "7", text: "Last 7 days" },
    { value: "28", text: "Last 28 days" },
    { value: "3", text: "Last 3 months" },
    { value: "6", text: "Last 6 months" },
    { value: "12", text: "Last 12 months" },
    { value: "16", text: "Last 16 months" },
    { value: "custom", text: "Custom" },
  ];

  importselectedFlag: string = "";
  importdefaultFlag: string = "https://flagpedia.net/data/flags/normal/us.png";
  @ViewChild('callAPIDialog') callAPIDialog!: TemplateRef<any>;
  @ViewChild('importKeywords') importKeywords!: TemplateRef<any>;
  importSelected = "us";

  theme: boolean = true;
  queryUparrow: any;
  queryDownarrow: any;
  ctrUpArrow: boolean = false;
  ctrDownArrow: boolean = false;
  positionUpArrow: boolean = false; backupFilteredData: any;
  userData: any;
  remainingCredits: any;
  totalCredits: any;
  remainingAuditCredits: any;
  totalAuditCredits: any;
  loading: boolean = true;
  // dropDownCountry!: { code: string; name: string; }[];
  // languageDropdown!: { code: string; name: string; }[];
  ;
  positionDownArrow: boolean = false;;
  impressionUpArrow: boolean = false;;
  impressionDownArrow: boolean = false;;
  clickUpArrow: boolean = false;;
  clickDownArrow: boolean = false;;
  cpcUpArrow: any;
  cpcDownArrow: any;
  sortArray: any;
  backupFilterData: any;
  uid?: any;
  isSubmitted: boolean = false;
  reportName: string = "";
  reportData: string = "";
  importedData: any[] = [];
  languageType: string = "en";
  importlanguageType: string = "en";
  languageDropdown = KeyWord.lckrLanguages;
  dropDownCountry = KeyWord.lckrCoutries;
  filterCount = 0;
  gscCountries = KeyWord.gscCountry;
  selectedGscCountry = 'USA'
  selectedDevice = 'DESKTOP'
  masterSelected:boolean = false;
  allSelect:boolean = false;

  get selectMenu() {
    return !this.theme ? 'testClass' : 'selectMenu'
  }
  get popover() {
    return !this.theme ? 'dark-popover ' : ''
  }
  @ViewChild('content') content: any;
  @ViewChild('filter') filterr: any;
  activeFilterTitle: string = "";
  selectedQuery: string = "CONTAINS";
  selectedCustomQuery: string = "INCLUDING_REGEX";
  queryTitle: string = "";
  queryUrl: string = "";
  activeQuaries: any[] = [];
  constructor(private themingService: ThemingService, private socket: Socket,
    private cookieServ: CookieService, private editorServie: EditorService, private route: ActivatedRoute, private router: Router,
    private toster: ToastrService, private dialog: MatDialog, private modal: NgbModal, private lckrService: LckrService) {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res;
    })
  }
  ngOnInit(): void {
    // setTimeout(() => {
    //   this.initGraphs();
    // });;
    this.uid = this.cookieServ.get("uid");
    this.getUserDetails();
    this.themingService.pingThemeName();
    // if('google_refresh_token' in localStorage){

    // }else{
    //   localStorage.removeItem('google_token');
    //     this.router.navigate(['/dashboard/integration'])
    // }
    // if('google_token' in localStorage){
    //   this.accessToken =  JSON.parse(localStorage?.getItem('google_token') || '');
    // }else{
    //   this.accessToken = ''
    // }
    // if(this.accessToken===''){
    //   this.getNewAccessToken();
    // }
    this.accessToken = JSON.parse(localStorage?.getItem('google_token') || '');
    this.getDates();
    this.dateValue = "Last 28 days";
    this.totalClicks = true;
  }

  getUserDetails() {
    this.editorServie.getUserprofile({ uid: this.uid }).subscribe((res:any) => {
      this.userData = res.userDetails[0];
    })
  }
  getCeCredits(){
    this.editorServie.getAllContentEditorData({ type: "GET", uid: this.uid }).subscribe((res: any) => {
      this.totalCredits = res.max_credits,
        this.remainingCredits = res.my_credits;
    });  
  }
  getAuditCredits(){
    let data = {
      type: "GET",
      uid: this.uid,
    };
    this.editorServie.getAndPostAudit(data).subscribe(res => {
      this.totalAuditCredits = res.max_credits,
        this.remainingAuditCredits = res.my_credits
    })
  }
  getMonthValue() {
    return this.radioArr.find(el => { return el.value === this.date })?.text;
  }
  changeData(event: any) {
    this.gscData = [];
    this.backupFilterData = [];
    this.backupFilteredData = [];
    this.backupGscData = [];
    this.queryData = [];
    this.queryyData = [];
    this.chart?.destroy();
    this.selected = event.value;
    this.getDates('selected');
    if(this.activeQuaries.length>0){
      this.selectFilters(this.activeQuaries.length - 1, 'afterDelete');
    }else{
      this.getSiteData();
      this.getQueryData();
      this.getChartData();
    }
  }
  getNewAccessToken() {
    this.editorServie.getNewToken().subscribe((res: any) => {
      localStorage.setItem('google_token', JSON.stringify(res.access_token));
      this.accessToken = res.access_token;
      this.getDates();
    })
  }
  getSiteLists() {
    this.editorServie.getSites(this.accessToken).subscribe((res: any) => {
      this.siteData = res.siteEntry;
      this.selected = res.siteEntry[0].siteUrl;
      this.getSiteData();
      this.getQueryData();
      this.getChartData();
    }, (err: any) => {
      this.loading = false;
      if (!!err && !!err?.error?.error?.code && err?.error?.error?.code == 401) {
        localStorage.removeItem('google_token');
        // this.getNewAccessToken();
        this.router.navigate(['/dashboard/integration'])
      }
    })
  }
  // allPageSelect(){
  //   this.queryyData = [];
  //   for (let i = 0; i < this.queryData.length; i++) {
  //     this.queryData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
  //     // this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
  //     this.masterSelected = false;
  //     if(this.queryData[i].isChecked){
  //       this.queryyData.push(this.queryData[i].keys[0])
  //     }
  //   }
  // }
  pageSelection(arg:string){
    this.queryyData = [];
    if(arg==='current'){
      this.queryData.forEach(el=>{
        el.isChecked = false;
        this.queryyData.push(el.keys[0]);
      })
    }else{
      this.backupFilterData.forEach((el:any)=>{
        el.isChecked = false;
        this.queryyData.push(el.keys[0])
      })
    }
    this.openModal('lckr')
  }
  closeModal(){
    this.modal.dismissAll();
    this.queryyData = [];
    this.queryData.forEach(e=>e.isChecked=false);
  }
  // checkAll(){
  //   this.queryyData = [];
  //   for (let i = 0; i < this.queryData.length; i++) {
  //     this.queryData[i].isChecked = this.allSelect == true ? true : this.masterSelected;
  //     // this.isAllChecked = this.allSelect == true ? true : this.masterSelected;
  //     if(this.queryData[i].isChecked){
  //       this.queryyData.push(this.queryData[i].keys[0])
  //     }
  //   }
  // }
  getSiteData(arg?: string) {
    var d = new Date();
    d.setMonth(d.getMonth() - 1);
    let dateObj;
    if (!!arg && arg === 'fromFilters') {
      dateObj = {
        "dimensionFilterGroups": [
          {
            "groupType": "AND",
            "filters": [
              {
                "dimension": this.activeFilterTitle,
                "operator": this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery,
                "expression": this.activeFilterTitle === 'COUNTRY' ? this.selectedGscCountry : this.activeFilterTitle === 'DEVICE' ? this.selectedDevice : this.activeFilterTitle === 'PAGE' ? this.queryUrl : this.queryTitle
              }
            ]
          }
        ],
        "startDate": this.startDate,
        "endDate": this.endDate,
        "aggregationType": "BY_PAGE",
      }
    } else {
      dateObj = {
        startDate: this.startDate,
        endDate: this.endDate,
        "aggregationType": "BY_PAGE",
      }
    }
    this.editorServie.getSiteData(this.selected, this.accessToken, dateObj).subscribe((res: any) => {
      this.gscData = res.rows;
    }, (err: any) => {
      if (!!err && !!err?.error?.error?.code && err?.error?.error?.code == 401) {
        localStorage.removeItem('google_token');
        // this.getNewAccessToken();
        this.router.navigate(['/dashboard/integration'])
      }
    })
  }
  initGraphs() {
    this.chart?.destroy()
    var ctx: any = ((document.getElementById("canvas")) as HTMLCanvasElement)?.getContext("2d");
    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labels,
        datasets: [
          {
            label: "Clicks",
            data: this.clickData,
            fill: false,
            borderColor: "#0785a391",
            borderWidth: 2
          },
        ]
      },
      options: {
        plugins: {},
        clip: false,
        responsive: true,
        elements: {
          point: {
            radius: 0
          }
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            type: 'linear',
            display: false,
            position: 'left',
          },

          y1: {
            type: 'linear',
            display: false,
            position: 'right',
            // grid line settings
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          },
          y2: {
            type: 'linear',
            display: false,
            position: 'left',
          },
          y3: {
            type: 'linear',
            display: false,
            suggestedMin: 0.01,
            position: 'left',
          },
          x: {
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
          }
        }
      },
      plugins: [
        {
          id: 'verticalLiner',
          afterInit: (chart: any, args, opts) => {
            chart.verticalLiner = {}
          },
          afterEvent: (chart: any, args, options) => {
            const { inChartArea } = args
            chart.verticalLiner = { draw: inChartArea }
          },
          beforeTooltipDraw: (chart: any, args, options) => {
            const { draw } = chart.verticalLiner
            if (!draw) return

            const { ctx } = chart
            const { top, bottom } = chart.chartArea
            const { tooltip } = args
            const x = tooltip?.caretX
            if (!x) return

            ctx.save()

            ctx.beginPath()
            ctx.moveTo(x, top)
            ctx.lineTo(x, bottom)
            ctx.stroke()

            ctx.restore()
          },
          beforeDraw: function (c: any) {
            var legends = c.legend.legendItems;
            legends.forEach(function (e: any) {
              if (e.text === 'Clicks') {
                e.fillStyle = '#0785a391';
              }
              if (e.text === 'Impressions') {
                e.fillStyle = '#0297529e';
              }
              if (e.text === 'Avg.CTR') {
                e.fillStyle = '#625f6282';
              }
              if (e.text === 'Avg.Positions') {
                e.fillStyle = '#b93e3aa3';
              }
            });
          }
        }
      ],
    });
  }
  changeActiveLink(title: string) {
    this.loading = true;
    this.activeLink = title;
    if (this.filterCount > 0) {
      this.getQueryData('fromFilters');
    } else {
      this.getQueryData();
    }
  }
  getChartData(arg?: string) {
    var d = new Date();
    d.setMonth(d.getMonth() - 1);
    let dateObj;
    if (!!arg && arg === 'fromFilters') {
      dateObj = {
        "dimensionFilterGroups": [
          {
            "groupType": "AND",
            "filters": [
              {
                "dimension": this.activeFilterTitle,
                "operator": this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery,
                "expression": this.activeFilterTitle === 'COUNTRY' ? this.selectedGscCountry : this.activeFilterTitle === 'DEVICE' ? this.selectedDevice : this.activeFilterTitle === 'PAGE' ? this.queryUrl : this.queryTitle
              }
            ]
          }
        ],
        "startDate": this.startDate,
        "endDate": this.endDate,
        "aggregationType": "BY_PAGE",
        "rowLimit": 500,
        "startRow": 0,
        "type": "web",
        "dimensions": [
          "DATE"
        ]
      }
    } else {
      dateObj = {
        startDate: this.startDate,
        endDate: this.endDate,
        "aggregationType": "BY_PAGE",
        "rowLimit": 500,
        "startRow": 0,
        "type": "web",
        "dimensions": [
          "DATE"
        ]
      }
    }

    this.editorServie.getSiteData(this.selected, this.accessToken, dateObj).subscribe((res: any) => {
      this.labels = res.rows.map((e: any) => { return new Date(e.keys[0]).toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' }) });
      this.clickData = res.rows.map((e: any) => { return e.clicks });
      this.impressionData = res.rows.map((e: any) => { return e.impressions });
      this.ctrData = res.rows.map((e: any) => { return (Math.round(e.ctr * 100) / 100).toFixed(2) });
      this.positionData = res.rows.map((e: any) => { return (Math.round(e.position * 100) / 100).toFixed(2) });
      setTimeout(() => {
        this.initGraphs();
        this.showChart();
      }, 1000);
    })
  }
  getQueryData(arg?: string) {
    var today = new Date();
    var d = new Date();
    d.setMonth(d.getMonth() - 1);
    let dateObj;
    if (!!arg && arg === 'fromFilters') {
      dateObj = {
        "dimensionFilterGroups": [
          {
            "groupType": "AND",
            "filters": [
              {
                "dimension": this.activeFilterTitle,
                "operator": this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery,
                "expression": this.activeFilterTitle === 'COUNTRY' ? this.selectedGscCountry : this.activeFilterTitle === 'DEVICE' ? this.selectedDevice : this.activeFilterTitle === 'PAGE' ? this.queryUrl : this.queryTitle
              }
            ]
          }
        ],
        "startDate": this.startDate,
        "endDate": this.endDate,
        "aggregationType": "BY_PAGE",
        "rowLimit": 500,
        "startRow": 0,
        "type": "web",
        "dimensions": [
          this.activeLink
        ]
      }
    } else {
      dateObj = {
        startDate: this.startDate,
        endDate: this.endDate,
        "aggregationType": "BY_PAGE",
        "rowLimit": 500,
        "startRow": 0,
        "type": "web",
        "dimensions": [
          this.activeLink
        ]
      }
    }
    // if(!!arg && arg==='fromFilters' && (this.activeLink==='COUNTRY' || this.activeLink==='DEVICE')){

    // }
    this.editorServie.getSiteData(this.selected, this.accessToken, dateObj).subscribe((res: any) => {
      if (!!res && !!res.rows && res.rows.length > 0) {
        res.rows.forEach((el: any) => {
          el['isChecked'] = this.allSelect===true ? true : false;
        })
        if (this.activeLink === 'COUNTRY') {
          let countries = KeyWord.gscCountry;
          res.rows = res.rows.map((e: any) => {
            let country = countries.find(el => e.keys[0] === el.code.toLocaleLowerCase())?.name.toLowerCase();
            e.keys[0] = country;
            return { ...e }
          });
        }
        this.queryData = res.rows;
        this.backupGscData = res.rows;
        this.backupFilterData = res.rows;
        this.backupFilteredData = res.rows;
        this.loading = false;
        // this.gscData = res.rows;
        this.filterData();
      } else {
        this.queryData = [];
        this.backupGscData = [];
        this.backupFilterData = [];
        this.backupFilteredData = [];
        // this.gscData = res.rows;
        this.loading = false;
        this.filterData();
      }

    })
  }
  getPosition(position: any) {
    return Math.ceil(position)
  }
  onTableDataChange() {
    this.tableSize = 50;

    const lastIndex = this.page * this.tableSize;
    const firstIndex = lastIndex + 1 - this.tableSize;
    this.tabWiseCount = this.backupGscData.length;
    const pageCount = this.tabWiseCount / this.tableSize;
    this.count = Math.ceil(pageCount);
    if (this.page == this.count) {
      this.totalData = firstIndex + "-" + this.tabWiseCount
    } else {
      this.totalData = firstIndex + "-" + lastIndex
    }
    this.queryData = this.backupGscData?.slice((this.page - 1) * this.tableSize, (this.page - 1) * this.tableSize + this.tableSize);
  }
  openDialog() {
    let modalRef = this.modal.open(this.content, { centered: true });
    // this.dialogRef = this.dialog.open(this.callAPIDialog, { width: '20%', panelClass: !this.theme ? 'theme-class' : '' });
  }
  onApply() {
    this.dateValue = this.radioArr.find(e => e.value === this.date)?.text || ''
    this.getDates();
    this.modal.dismissAll();
    this.queryyData= [];

  }
  getDates(arg?: any) {
    var today = new Date();
    var d = new Date();
    switch (this.date) {
      case "7":
        d.setDate(d.getDate() - 7)
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "28":
        d.setDate(d.getDate() - 28);
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "3":
        d.setMonth(d.getMonth() - 3);
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "6":
        d.setMonth(d.getMonth() - 6);
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "12":
        d.setMonth(d.getMonth() - 12);
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "16":
        d.setMonth(d.getMonth() - 16);
        this.startDate = d.toLocaleDateString('en-CA');
        this.endDate = new Date().toLocaleDateString('en-CA');
        break;
      case "custom":
        this.startDate = this.customStartDate.toLocaleDateString('en-CA');
        this.endDate = this.customEndDate.toLocaleDateString('en-CA');
        break;
      default:
        break;
    }
    if (!arg && arg !== 'selected') {
      this.getSiteLists();
    }
  }
  showDecimals(val: any) {
    return (Math.round(val * 100) / 100).toFixed(2)
  }
  showChart() {
    this.chart.data.datasets = [];
    if (this.totalClicks) {
      this.chart.data.datasets.push(
        {
          yAxisID: 'y',
          label: "Clicks",
          data: this.clickData,
          fill: false,
          borderColor: "#0785a391",
          borderWidth: 2
        },
      )
    }
    if (this.totalImpressions) {
      this.chart.data.datasets.push(
        {
          yAxisID: 'y1',
          label: "Impressions",
          data: this.impressionData,
          fill: false,
          borderColor: "#0297529e",
          borderWidth: 2
        },
      )
    }
    if (this.avgCtr) {
      this.chart.data.datasets.push(
        {
          yAxisID: 'y2',
          label: "Avg.CTR",
          data: this.ctrData,
          fill: false,
          borderColor: "#625f6282",
          borderWidth: 2
        },
      )
    }
    if (this.avgPosition) {
      this.chart.data.datasets.push(
        {
          yAxisID: 'y3',
          label: "Avg.Positions",
          data: this.positionData,
          fill: false,
          borderColor: "#b93e3aa3",
          borderWidth: 2
        },
      )
    }
    if (!this.totalClicks && !this.totalImpressions && !this.avgCtr && !this.avgPosition) {
      this.chart.data.datasets.push(
        {
          yAxisID: 'y',
          label: "Clicks",
          data: this.clickData,
          fill: false,
          borderColor: "#0785a391",
          borderWidth: 2
        },
      )
    }
    this.chart.update();
  }
  sortTable(arg: string) {
    if (arg === 'query') {
      if (!this.queryUparrow && !this.queryDownarrow) {
        this.queryUparrow = true;
      } else if (!!this.queryUparrow) {
        this.queryUparrow = false;
        this.queryDownarrow = true;
      } else if (!!this.queryDownarrow) {
        this.queryUparrow = false;
        this.queryDownarrow = false;
      }
      this.ctrUpArrow = false;
      this.ctrDownArrow = false;
      this.positionUpArrow = false;
      this.positionDownArrow = false;
      this.impressionUpArrow = false;
      this.impressionDownArrow = false;
      this.clickUpArrow = false;
      this.clickDownArrow = false;
      // this.totalKeywordUpArrow = false
      // this.totalKeywordDownArrow = false
      // this.weakKeywordUpArrow = false
      // this.weakKeywordDownArrow = false

      if (this.queryUparrow) {
        // this.sortArray.push('-volume')
        // this.volDownarrow = false
        this.filterData();
      } else if (this.queryDownarrow) {
        // this.sortArray.push('volume');
        // this.volUparrow = false;
        this.filterData();
      } else {
        this.filterData();
      }
    } else if (arg === 'click') {
      if (!this.clickUpArrow && !this.clickDownArrow) {
        this.clickUpArrow = true;
      } else if (!!this.clickUpArrow) {
        this.clickUpArrow = false;
        this.clickDownArrow = true;
      } else if (!!this.clickDownArrow) {
        this.clickUpArrow = false;
        this.clickDownArrow = false;
      }
      // this.cpcUpArrow = !this.cpcUpArrow;
      // this.cpcUpArrow == true ? this.cpcUpArrow = true : this.cpcDownArrow = true;
      this.queryUparrow = false;
      this.queryDownarrow = false;
      this.impressionUpArrow = false;
      this.impressionDownArrow = false;
      this.ctrUpArrow = false;
      this.ctrDownArrow = false;
      this.positionUpArrow = false;
      this.positionDownArrow = false;
      if (this.clickUpArrow) {
        // this.sortArray.push('-cpc')
        this.filterData();
      } else if (this.clickDownArrow) {
        // this.sortArray.push('cpc')
        this.filterData();
      } else {
        this.filterData();
      }
    } else if (arg === 'impressions') {
      if (!this.impressionUpArrow && !this.impressionDownArrow) {
        this.impressionUpArrow = true;
      } else if (!!this.impressionUpArrow) {
        this.impressionUpArrow = false;
        this.impressionDownArrow = true;
      } else if (!!this.impressionDownArrow) {
        this.impressionUpArrow = false;
        this.impressionDownArrow = false;
      }
      this.queryUparrow = false;
      this.queryDownarrow = false;
      this.clickUpArrow = false;
      this.clickDownArrow = false;
      this.ctrUpArrow = false;
      this.ctrDownArrow = false;
      this.positionUpArrow = false;
      this.positionDownArrow = false;
      if (this.impressionUpArrow) {
        // this.sortArray.push('-lda')
        this.filterData();
      } else if (this.impressionDownArrow) {
        // this.sortArray.push('lda')
        this.filterData();
      } else {
        this.filterData();
      }
    } else if (arg === 'position') {
      if (!this.positionUpArrow && !this.positionDownArrow) {
        this.positionUpArrow = true;
      } else if (!!this.positionUpArrow) {
        this.positionUpArrow = false;
        this.positionDownArrow = true;
      } else if (!!this.positionDownArrow) {
        this.positionUpArrow = false;
        this.positionDownArrow = false;
      }
      // this.serpUpArrow = !this.serpUpArrow;
      // this.serpUpArrow == true ? this.serpUpArrow = true : this.serpDownArrow = true;
      this.queryUparrow = false;
      this.queryDownarrow = false;
      this.clickUpArrow = false;
      this.clickDownArrow = false;
      this.ctrUpArrow = false;
      this.ctrDownArrow = false;
      this.impressionUpArrow = false;
      this.impressionDownArrow = false;
      if (this.positionUpArrow) {
        // this.sortArray.push('-serp_score')
        this.filterData();
      } else if (this.positionDownArrow) {
        // this.sortArray.push('serp_score')
        this.filterData();
      } else {
        this.filterData();
      }
    } else if (arg === 'ctr') {
      if (!this.ctrUpArrow && !this.ctrDownArrow) {
        this.ctrUpArrow = true;
      } else if (!!this.ctrUpArrow) {
        this.ctrUpArrow = false;
        this.ctrDownArrow = true;
      } else if (!!this.ctrDownArrow) {
        this.ctrUpArrow = false;
        this.ctrDownArrow = false;
      }
      // this.serpUpArrow = !this.serpUpArrow;
      // this.serpUpArrow == true ? this.serpUpArrow = true : this.serpDownArrow = true;
      this.queryUparrow = false;
      this.queryDownarrow = false;
      this.clickUpArrow = false;
      this.clickDownArrow = false;
      this.positionDownArrow = false;
      this.positionUpArrow = false;
      this.impressionUpArrow = false;
      this.impressionDownArrow = false;
      if (this.ctrUpArrow) {
        // this.sortArray.push('-serp_score')
        this.filterData();
      } else if (this.ctrDownArrow) {
        // this.sortArray.push('serp_score')
        this.filterData();
      } else {
        this.filterData();
      }
    }
  }
  filterData() {
    let a = JSON.parse(JSON.stringify(this.backupFilteredData));
    let filterData = a;
    if (this.queryUparrow) {
      filterData = filterData.sort((a: any, b: any) => a.keys[0]?.localeCompare(b.keys[0]));
    } else if (this.queryDownarrow) {
      filterData = filterData.sort((a: any, b: any) => b.keys[0].localeCompare(a.keys[0]));
    } else if (this.clickUpArrow) {
      filterData = filterData.sort((a: any, b: any) => a.clicks - b.clicks);
    } else if (this.clickDownArrow) {
      filterData = filterData.sort((a: any, b: any) => b.clicks - a.clicks);
    } else if (this.impressionUpArrow) {
      filterData = filterData.sort((a: any, b: any) => a.impressions - b.impressions);
    } else if (this.impressionDownArrow) {
      filterData = filterData.sort((a: any, b: any) => b.impressions - a.impressions);
    } else if (this.ctrUpArrow) {
      filterData = filterData.sort((a: any, b: any) => a.ctr - b.ctr);
    } else if (this.ctrDownArrow) {
      filterData = filterData.sort((a: any, b: any) => b.ctr - a.ctr);
    } else if (this.positionUpArrow) {
      filterData = filterData.sort((a: any, b: any) => a.position - b.position);
    } else if (this.positionDownArrow) {
      filterData = filterData.sort((a: any, b: any) => b.position - a.position);
    } else {
      filterData = a;
    }
    this.backupGscData = filterData;
    this.onTableDataChange();
  }
  queryyData: any[] = [];
  changeKeyword() {
    this.queryyData = this.backupGscData.filter((e: any) => e.isChecked).map((el: any) => el.keys[0]);
    if(!this.allSelect){
      this.masterSelected = this.queryData.every((item: any) => {
        return item.isChecked == true;
      });
    }else{
      this.masterSelected = false;
    }
  }
  openModal(arg: string) {
    this.reportData = this.queryyData.toString();
    this.reportData = this.reportData.split(",").join("\n")
    if (arg === 'lckr') {
      let modalRef = this.modal.open(this.importKeywords, { windowClass: !this.theme ? 'dark-modal' : '' });
    }
    if (arg === 'ce') {
      let modalRef = this.modal.open(BulkContentEditorComponent, { windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
      modalRef.componentInstance.country = "United States";
      modalRef.componentInstance.language = "en";
      modalRef.componentInstance.queryData = this.queryyData;
      modalRef.result.then(e => {
        if (!!e && e !== undefined) {
          let obj = {
            "type": "POST",
            "uid": this.uid,
            "bulkAry": e,
            "retry": "false",
            "aid": "",
            "bulk": "true"
          }
          this.editorServie.addContentEditorData(obj).subscribe(res => {
            if (res?.message && res.status == false) {
              this.toster.error(res.message)
            }
            if (!!res && res?.aid?.length > 0) {
              res.aid.forEach((el: any) => {
                this.socket.emit("updater", el);
              });
              this.queryData.forEach(el => {
                el['isChecked'] = false;
              })
              window.open(`${window.location.origin}/dashboard/content-editor/editors`, '_blank')
            }
          });
        }
      });
    }
    if (arg === 'audit') {
      let modalRef = this.modal.open(BulkAuditComponent, { windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
      modalRef.componentInstance.country = "us";
      modalRef.componentInstance.language = "en";
      modalRef.componentInstance.queryData = this.queryyData;
      modalRef.result.then(e => {
        if (!!e && e !== undefined) {
          let obj = {
            "type": "POST",
            "uid": this.uid,
            "bulkAry": e,
            "retry": "false",
            "aid": "",
            "bulk": "true"
          }
          this.editorServie.getAndPostAudit(obj).subscribe(res => {
            if (res?.message && res.status == false) {
              this.toster.error(res.message)
            }
            if (!!res && res?.aid?.length > 0) {
              res.aid.forEach((el: any) => {
                this.socket.emit("updater", el);
              });
              this.queryData.forEach(el => {
                el['isChecked'] = false;
              })
              window.open(`${window.location.origin}/dashboard/audit-report/audits`, '_blank')
            }
          });
        }
      });
    }

  }
  createReport() {
    this.importedData = [];
    this.isSubmitted = true;
    this.importedData = this.reportData.split('\n').filter(item => item);
    // if (this.importedData.length < 7000) {

    let Obj: any = {
      data: {
        questions: [],
        suggested: []
      }
    }
    this.importedData.forEach((v: any) => {
      let _v = v.split(" ")[0];
      if (["will", "why", "where", "which", "when", "what", "are", "can", "how", "what's", "who", "whose", "how", "whom", "who's", "Does"].includes(_v)) {
        Obj.data.questions.push(v);
      } else {
        Obj.data.suggested.push(v);
      }
    })

    let data = {
      // "type": "customKeywords",
      // "uid": this.uid,
      "country": this.importSelected,
      "langauge": this.importlanguageType,
      "report_name": this.reportName,
      "keywords": this.importedData,
      type: "C"
      // "totalKeywords": this.importedData.length,
      // "retry": "FALSE"
    }
    this.lckrService.importedReport(data).subscribe((res: any) => {
      if (!!res) {
        // this.getLckrImportedData();
        this.modal.dismissAll();
        window.open(`${window.location.origin}/dashboard/lckr/keyword_finder2?from=gsc`, '_blank')
        // this.dismissImported();
        this.isSubmitted = false;
      }
    });
    // }


  }
  searchDropDownData(event: any, arg: string) {
    let key = event.target.value.toLowerCase();
    if (arg == 'country') {
      this.dropDownCountry = KeyWord.lckrCoutries.filter(e => {
        return e.name.toLowerCase().search(key) >= 0
      })
    } else if (arg == 'language') {
      this.languageDropdown = KeyWord.lckrLanguages.filter(e => {
        return e.name.toLowerCase().search(key) >= 0
      })
    }
  }
  getSelectedFlag(code: string, country: string, arg: string) {
    if (arg === 'lckr') {
      this.importselectedFlag = `https://flagpedia.net/data/flags/normal/${code}.png`;
      // this.countryValue = `${country}:${code}`;
    }
  }
  changeQueryData(arg: any) {
    this.selectedQuery = arg.value
  }
  changeCustomQueryData(arg: any) {
    this.selectedCustomQuery = arg.value
  }
  openFilterDialog(arg: string) {
    this.activeFilterTitle = arg;
    let modalRef = this.modal.open(this.filterr, { centered: true })
  }
  onQueryApply() {
    this.filterCount += 1;
    if (this.activeFilterTitle === 'QUERY') {
      let isAvailable = this.activeQuaries.some(el => el.query === this.activeFilterTitle);
      if (isAvailable) {
        let index = this.activeQuaries.findIndex(x => x.query === this.activeFilterTitle);
        this.activeQuaries.splice(index, 1, { query: this.activeFilterTitle, type: this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery, name: this.queryTitle })
      } else {
        this.activeQuaries.push({ query: this.activeFilterTitle, type: this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery, name: this.queryTitle })
      }
    } else if (this.activeFilterTitle === 'PAGE') {
      let isAvailable = this.activeQuaries.some(el => el.query === this.activeFilterTitle);
      if (isAvailable) {
        let index = this.activeQuaries.findIndex(x => x.query === this.activeFilterTitle);
        this.activeQuaries.splice(index, 1, { query: this.activeFilterTitle, type: this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery, name: this.queryUrl })
      } else {
        this.activeQuaries.push({ query: this.activeFilterTitle, type: this.selectedQuery === 'CUSTOM' ? this.selectedCustomQuery : this.selectedQuery, name: this.queryUrl })
      }
    } else {
      let isAvailable = this.activeQuaries.some(el => el.query === this.activeFilterTitle);
      if (isAvailable) {
        let index = this.activeQuaries.findIndex(x => x.query === this.activeFilterTitle);
        this.activeQuaries.splice(index, 1, { query: this.activeFilterTitle, type: 'EQUALS', name: this.activeFilterTitle == 'COUNTRY' ? this.selectedGscCountry : this.selectedDevice })
      } else {
        this.activeQuaries.push({ query: this.activeFilterTitle, type: 'EQUALS', name: this.activeFilterTitle == 'COUNTRY' ? this.selectedGscCountry : this.selectedDevice })
      }
    }
    // this.getQueryData('fromFilters');
    // this.getChartData('fromFilters');
    // this.getSiteData('fromFilters');
    this.modal?.dismissAll();
    // this.selectedQuery="CONTAINS";
    // this.selectedCustomQuery="INCLUDING_REGEX";
    // this.queryTitle = "";
    // this.queryUrl = "";
    // this.activeFilterTitle = "QUERY";
    // this.selectedGscCountry = "USA";
    // this.selectedDevice = "DESKTOP";
    this.selectFilters(this.activeQuaries.length - 1, 'afterDelete')
  }
  selectFilters(index: number, arg?: string) {
    let selectedFilterData = this.activeQuaries[index];
    this.activeFilterTitle = selectedFilterData.query;
    if (this.activeFilterTitle === 'QUERY') {
      if (selectedFilterData.name == "INCLUDING_REGEX" || selectedFilterData.name == "EXCLUDING_REGEX") {
        this.selectedQuery = "CUSTOM";
        this.selectedCustomQuery = selectedFilterData.type;
      } else {
        this.selectedQuery = selectedFilterData.type;
      }
      this.queryTitle = selectedFilterData.name
    } else if (this.activeFilterTitle === 'PAGE') {
      if (selectedFilterData.name == "INCLUDING_REGEX" || selectedFilterData.name == "EXCLUDING_REGEX") {
        this.selectedQuery = "CUSTOM";
        this.selectedCustomQuery = selectedFilterData.type;
      } else {
        this.selectedQuery = selectedFilterData.type;
      }
      this.queryUrl = selectedFilterData.name
    } else {
      if (this.activeFilterTitle === 'COUNTRY') {
        this.selectedGscCountry = selectedFilterData.name;
      } else {
        this.selectedDevice = selectedFilterData.name
      }
    }
    if (!!arg && arg === 'afterDelete') {
      this.getQueryData('fromFilters');
      this.getChartData('fromFilters');
      this.getSiteData('fromFilters');
    } else {
      this.modal.open(this.filterr, { centered: true });
    }
  }
  deleteFilter(index: number) {
    this.activeQuaries.splice(index, 1);
    if (this.activeQuaries.length == 0) {
      this.selectedQuery = "CONTAINS";
      this.selectedCustomQuery = "INCLUDING_REGEX";
      this.queryTitle = "";
      this.queryUrl = "";
      this.activeFilterTitle = "QUERY";
      this.selectedGscCountry = "USA";
      this.selectedDevice = "DESKTOP";
      this.getSiteData();
      this.getQueryData();
      this.getChartData();
    } else {
      this.selectFilters(this.activeQuaries.length - 1, 'afterDelete')
    }
  }
}
